import {AfterViewChecked, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {RouteComponentBase} from 'app/shared/models/route-component-base';
import {CommonDataService} from 'app/services/common-data.service';
import {Versions} from 'app/shared/models/vesions';
import {CommonService} from '../../../services/common.service';
import {BufferGraphService} from "../../services/buffer-graph.service";
import {BGChartType} from "../../models/b-g-chart-type";

type RegistryData = { success: boolean, versionNotCompatible: boolean, isAdmin: boolean};

@Component({
    selector: 'buffer-graph-outer-layer',
    templateUrl: './buffer-graph-outer-layer.component.html',
    styleUrls: [
        '../../../shared/styles/custom-scroll.css',
        '../../../slick-grid/stocks-grid-style.css',
        '../../../marketing-purchase/styles/marketing-purchase.css',
        '../../../shared/styles/buttons.css',
        '../../../shared/styles/common-module-view.css',
        './buffer-graph-outer-layer.component.css'
    ]
})

export class BufferGraphOuterLayerComponent extends RouteComponentBase<RegistryData> implements OnInit, OnDestroy, AfterViewChecked{
    constructor(elementRef: ElementRef,
                @Inject(PLATFORM_ID) platformId: any,
                commonData: CommonDataService,
                private readonly bufferGraphService: BufferGraphService,
                private readonly commonService: CommonService,
                private readonly router: Router,
                private readonly route: ActivatedRoute,
    ){
        super(elementRef, platformId, commonData, 'BufferGraph');
        this.versions = new Versions();
        this.type = BGChartType.Main;
    }

    public id: number;
    public isAdmin: boolean;
    public type: BGChartType;
    private versions: Versions;


    ngOnInit() {
        super.ngOnInit();
        const id = this.route.snapshot.paramMap.get('id');
        if (id)
            this.id = Number(id);

    }

    ngAfterViewChecked(){

    }

    ngOnDestroy() {
    }

    protected initialDataLoader = (): Observable<RegistryData> => {
        return this.commonService.getVersionPermission('Chart', this.versions.chart);
    }

    protected onInitialDataLoaded = async (data: RegistryData, hideLoadingImg: () => void): Promise<void> =>{
        hideLoadingImg();

        if (!data || !data.success){
            this.translateService.get('LoadBufferGraphError')
                .subscribe(error => {
                    this.commonData.showErrors([error]);
                });
            return;
        } else if (data.versionNotCompatible) {
            this.translateService.get('VersionNotCompatible')
                .subscribe( error =>{
                    this.commonData.showErrors([error]);
                    this.router.navigateByUrl('versions-not-compatible');
                });
            return;
        }


        this.isInitialized = true;
    };

    private showErrors = (errors: string[], onOk?: () => void): void => {
        this.commonData.showErrors(errors, onOk);
    }

    public onShowErrors = (data: { errors: string[], isOnInitiating?: boolean }): void => {
        this.showErrors(data.errors);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/buffer-graph-outer-layer.component/buffer-graph-outer-layer.component.ts